import * as types from '../contents/actionTypes'
export const receiveProducts = products => ({
        type : types.RECEIVE_PRODUCTS ,
        products
})


export const addToCart = productId => ({
    type : types.ADD_TO_CART ,
    productId
})


export const removeFromCart = productId => ({
    type : types.REMOVE_FROM_CART ,
    productId
})

export const removeProductFromCart = productId => ({
    type : types.REMOVE_PRODUCT_FROM_CART ,
    productId
})

export const receiveCart = cart => ({
    type : types.RECEIVE_CART ,
    cart
})


export const resetCart = cart => ({
    type : types.RESET_CART ,
    cart
})


export const addToUserCart = productId => ({
    type : types.ADD_TO_USER_CART ,
    productId
})


export const removeFromUserCart = productId => ({
    type : types.REMOVE_FROM_USER_CART ,
    productId
})
export const removeProductFromUserCart = productId => ({
    type : types.REMOVE_PRODUCT_FROM_USER_CART ,
    productId
})


export const receiveBranch = branch => ({
    type : types.RECEIVE_BRANCH ,
    branch
})




export const toolbar = show => ({
    type : types.TOOLBAR ,
    show
})

